import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { AlertConfirmationAction, AlertConfirmationDetails } from 'AgentApp/ts/interfaces/agent-event';

const ACTION_LABELS: Record<AlertConfirmationAction, string> = {
    create: 'Create alert on',
    edit: 'Edit alert on',
    delete: 'Delete alert on',
};

@Component({
    selector: 'ycn-alert-confirmation-details',
    imports: [],
    templateUrl: './alert-confirmation-details.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertConfirmationDetailsComponent {
    protected readonly details = input.required<AlertConfirmationDetails>();

    protected readonly actionLabel = computed(() => ACTION_LABELS[this.details().action]);

    protected readonly hasCondition = computed(() => {
        const details = this.details();
        return !!details.description && details.description !== details.alert_type_label;
    });

    protected readonly isEdit = computed(() => this.details().action === 'edit');
}
